import React from 'react';
import './App.css';

const Product = (props) => {
	const storeId = process.env.AMAZON_STORE_ID;
	const src = `//ws-na.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=US&ASIN=${props.product.asin}&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL250_&tag=${storeId}`;

	return (
		<div className='product'>
			<img
				src={src}
				alt={`${props.product.brand} ${props.product.title_preview}`}/>
			<div className='brand'>{props.product.brand}</div>
			<div className='product-title-short>'>{props.product.title_preview}</div>
		</div>
	)
}

export default Product;




// WEBPACK FOOTER //
// ./src/Product.jsx